import { CourtCaseRedirect } from '@app/modules/CourtCases/CourtCaseRedirect'
import { CourtCases } from '@app/modules/CourtCases/CourtCases'
import { getCourtCasesBasePath, getCourtCasePath } from '@app/modules/CourtCases/paths'

export const routes = [
  {
    path: getCourtCasesBasePath(':id'),
    component: CourtCaseRedirect,
    exact: true
  },
  {
    path: getCourtCasePath(':id', ':courtCaseUuid'),
    component: CourtCases,
    exact: false
  }
]
